import {RemotePostProvidersList} from 'data/usecases/private/authorizations/remote-post-providers-list';
import {PostProvidersList} from 'domain/usecases/private/authorizations/post-providers-list';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makePostProvidersList = (): PostProvidersList =>
	new RemotePostProvidersList(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.providers),
		makeAuthorizeHttpClientDecorator(),
	);
